import { MenuItem, TextField } from '@mui/material';
import React, { useState } from 'react';
import '../../components/app/common.scss';
import CustomSelect from './customSelect';


function CustomUnitInput({ label, placeholder, amount,
    amountType = 'number',
    parent = undefined,
    prop = '',
    className = '',
    unit = {
        value: undefined,
        options: [],
        prop: undefined,
        renderValue: (selected) => selected,
        renderOptions: (c, i) => <MenuItem key={i} value={c}>{c.name}</MenuItem>
    }, onChange }) {
    const handleAmountChange = (e, onChange) => {
        e.preventDefault();
        if (parent) {
            parent[prop].amount = e.target.value;
        }
        onChange(e);
    }
    const handleInputChange = (e, onChange) => {
        e.preventDefault();
        if (parent) {
            parent[prop].unit = e.target.value;
        }
        onChange(e);
    }

    return (
        <div className={'unit-input-wrp '+ className}>
            <label>{label}</label>
            <TextField
                className="input-primary"
                type={amountType}
                fullWidth
                placeholder={placeholder}
                value={amount}
                required
                InputLabelProps={{ shrink: false }}
                onChange={(e) => handleAmountChange(e, onChange)} />
            <CustomSelect value={unit.value}
                onChange={(e) => handleInputChange(e, onChange)} options={unit.options}
                className='input-secondary'
                required
                renderValue={unit.renderValue}
                renderOptions={unit.renderOptions}
            />
        </div>
    );
}

export default CustomUnitInput;